<template>
	<div class="monthDay" :class="[
			{ disabled: item.isDisabled},
			{ noScheduleNoChecks: noScheduleNoChecks(item) }]">
		<div class="head">
			<div v-if="item.date" class="date item">

				<tool-tip
						text="Month"
						content-class="top"
						:position="{ top: 'top' }"
				>
					<div class="iconWrap">
						<svg-sprite width="20" height="20" icon-id="calendar0	"/>
						<div class="mm">{{ modMonthDay[0] }}</div>
					</div>
				</tool-tip>

				<tool-tip
						text="Date"
						content-class="top"
						:position="{ top: 'top' }"
				>
					<div class="value">
						<div class="dd">{{ modMonthDay[1] }}</div>
					</div>
				</tool-tip>

				<div class="dayName">{{ item.name }}</div>
			</div>

			<div v-if="!item.isDisabled" class="dayControls item">
				<tool-tip
						text="View comments"
						content-class="top"
						:position="{ top: 'top' }"
				>
					<icon-btn
							@updateEvent="onEventIconBtn('comment')"
							custom-class="infoBTN"
							:icon-attrs="{iconId: 'comment', width: 18, height: 18, color: '#1dab39',}"
					></icon-btn>
				</tool-tip>

				<tool-tip
						v-if="isBtnWorkTime"
						text="Edit work time"
						content-class="top"
						:position="{ top: 'top' }"
				>
					<icon-btn
							@updateEvent="onEventIconBtn('openEditTime')"
							custom-class="infoBTN"
							:icon-attrs="{iconId: 'statistics-chart-graph', width: 18, height: 18, color: '#009dff',}"
					></icon-btn>
				</tool-tip>

				<tool-tip
						v-if="isBtnSick"
						text="Edit status sickleave"
						content-class="top"
						:position="{ top: 'top' }"
				>
					<icon-btn
							@updateEvent="onEventIconBtn('sick')"
							custom-class="infoBTN"
							:icon-attrs="{iconId: 'Medicine', width: 18, height: 18, color: '#ff3c3c',}"
					></icon-btn>
				</tool-tip>
			</div>

			<div v-if="item.total_time && !noScheduleNoChecks(item) && !isVac && !isSick && !isDuty && !isRemote && !isHoliday"
			     class="total_time item">
				<div class="totalTimeRow">
					<svg-sprite width="18" height="18" icon-id="TimeCheck"/>
					<div class="value">{{ toHm(item.total_time) }}</div>
				</div>
			</div>
			<template v-else>
				<template v-if="isVac">
					<div class="eventDay vacation">
						<div class="icon" :class="{ payed: item.vacation.payed }">
							<svg-sprite width="38" height="38" :icon-id="vacIcon"/>
						</div>
						<div class="text">{{ vacText }}</div>
					</div>
				</template>

				<template v-if="isSick">
					<div class="eventDay sick">
						<div class="icon" :class="{ payed: item.sick.payed }">
							<svg-sprite width="38" height="38" icon-id="Medicine"/>
						</div>
						<div class="text">{{ sickText }}</div>
					</div>
				</template>

				<template v-if="isDuty">
					<div class="eventDay duty">
						<div class="icon" :class="{ payed: item.duty.payed }">
							<svg-sprite width="38" height="38" icon-id="Binoculars"/>
						</div>
						<div class="text">Duty</div>
					</div>
				</template>

				<template v-if="isRemote">
					<div class="eventDay remote">
						<div class="icon" :class="{ payed: item.duty.payed }">
							<svg-sprite width="38" height="38" icon-id="HomeWifi"/>
						</div>
						<div class="text">Remote</div>
					</div>
				</template>

				<template v-if="isHoliday">
					<div class="eventDay holiday">
						<div class="icon" :class="{ payed: item.holiday.payed }">
							<svg-sprite width="38" height="38" :icon-id="holidayIcon"/>
						</div>
						<div class="text">{{ holidayText }}</div>
					</div>
				</template>
			</template>

		</div>

		<template v-if="!noScheduleNoChecks(item) && !isVac && !isSick && !isDuty && !isRemote && !isHoliday" >
			<div class="main">
				<div class="checkWrap itemWrap">
					<div v-if="item.check_in" class="check in item">
						<svg-sprite width="18" height="18" icon-id="ArrowRightToArc"/>
						<div class="value">{{ toHm(item.check_in) }}</div>
					</div>
					<div class="sep">-</div>
					<div v-if="item.check_out" class="check out item">
						<div class="value">{{ toHm(item.check_out) }}</div>
						<svg-sprite width="18" height="18" icon-id="ArrowRightFromArc"/>
					</div>
				</div>

				<div v-if="item.total_time && !noScheduleNoChecks(item) && !isVac && !isSick && !isDuty && !isRemote && !isHoliday"
				     class="total_time item itemWrap">
					<div class="totalTimeRow">
						<svg-sprite width="18" height="18" icon-id="TimeCheck"/>
						<div class="value">{{ toHm(item.total_time) }}</div>
					</div>
				</div>

				<div v-if="item.schedule_in && item.schedule_out" class="scheduleWrap itemWrap">
					<svg-sprite width="18" height="18" icon-id="calendar1"/>
					<div class="schedule in item">
						<div class="value">{{ toHm(item.schedule_in) }}</div>
					</div>
					<div class="sep">-</div>
					<div class="schedule out item">
						<div class="value">{{ toHm(item.schedule_out) }}</div>
					</div>
					<div class="ow" v-if="owInfo">
			    <span class="owBadge" :class="`owBadge--${ owInfo.mod }`">
			      {{ owInfo.text }}
			    </span>
					</div>
				</div>
			</div>
		</template>
		<template v-if="noScheduleNoChecks(item)">
			<div class="iconWr">
				<svg-sprite width="48" height="48" icon-id="snoozeWeekend"/>
			</div>
		</template>

		<template v-if="isVac">
			<div class="eventDay vacation">
				<div class="icon" :class="{ payed: item.vacation.payed }">
					<svg-sprite width="38" height="38" :icon-id="vacIcon"/>
				</div>
				<div class="text">{{ vacText }}</div>
			</div>
		</template>

		<template v-if="isSick">
			<div class="eventDay sick">
				<div class="icon" :class="{ payed: item.sick.payed }">
					<svg-sprite width="38" height="38" icon-id="Medicine"/>
				</div>
				<div class="text">{{ sickText }}</div>
			</div>
		</template>

		<template v-if="isDuty">
			<div class="eventDay duty">
				<div class="icon" :class="{ payed: item.duty.payed }">
					<svg-sprite width="38" height="38" icon-id="Binoculars"/>
				</div>
				<div class="text">Duty</div>
			</div>
		</template>

		<template v-if="isRemote">
			<div class="eventDay remote">
				<div class="icon" :class="{ payed: item.duty.payed }">
					<svg-sprite width="38" height="38" icon-id="HomeWifi"/>
				</div>
				<div class="text">Remote</div>
			</div>
		</template>

		<template v-if="isHoliday">
			<div class="eventDay holiday">
				<div class="icon" :class="{ payed: item.holiday.payed }">
					<svg-sprite width="38" height="38" :icon-id="holidayIcon"/>
				</div>
				<div class="text">{{ holidayText }}</div>
			</div>
		</template>

	</div>
</template>

<script>
// helpers
import {
	toMonthDay, toHm, noScheduleNoChecks,
	getObjInfo,
} from "@/helper";
import IconBtn from "@/pages/Account/IconBtn/iconBtn.vue";
import ToolTip from "@/shared/ToolTip/ToolTip.vue";
export default {
	name: "MonthDay",
	components: { ToolTip, IconBtn },
	props: {
		item: Object,
		isBtnSick: Boolean,
		isBtnWorkTime: Boolean,
	},
	computed: {
		isSick() {
			return getObjInfo(this.item.sick);
		},
		sickIcon() {
			return this.item.sick.payed ? 'sickPaid' : 'sickNoPaid';
		},
		sickText() {
			return this.item.sick.payed ? 'Sick' : 'Unpaid sick';
		},
		isVac() {
			return getObjInfo(this.item.vacation);
		},
		vacIcon() {
			return this.item.vacation.payed ? 'vacPaid' : 'vacNoPaid';
		},
		vacText() {
			return this.item.vacation.payed ? 'Vacation' : 'Unpaid vacation';
		},
		holidayIcon() {
			return this.item.holiday ? 'icon-bbq' : 'icon-bbq';
		},
		holidayText() {
			return this.item.holiday;
		},

		/*
		 * Обчислюємо різницю між відпрацьованим і запланованим часом.
		 * @return {{diff:number, mod:'less'|'more'|'ok', text:string}|null}
		 *   diff  – хвилини (total - scheduled)
		 *   mod   – клас для забарвлення
		 *   text  – відформатований текст із знаком: "+HH:mm", "-HH:mm" або "=00:00"
		 */
		owInfo() {
			const it = this.item || {};
			if (!(it.schedule_in && it.schedule_out && it.total_time)) return null;

			const scheduled = this.getScheduledMinutes(it.schedule_in, it.schedule_out);
			const total = this.parseToMinutes(it.total_time);
			const diff = total - scheduled;

			let mod; // колір
			let text; // відображення

			if (diff > 0) {
				// Переробив
				mod = 'more';
				text = `+${ this.formatMinutes(diff) }`;
			} else if (diff < 0) {
				// Не доробив
				mod = 'less';
				text = `-${ this.formatMinutes(Math.abs(diff)) }`;
			} else {
				// Рівно скільки треба
				mod = 'ok';
				text = `=${ this.formatMinutes(0) }`;
			}

			return { diff, mod, text };
		}
	},
	data: () => ({
		isRemote: false,
		isDuty: false,
		isHoliday: false,
		duty: null,
		remote: null,
		holiday: null,
		modMonthDay: [],
	}),
	methods: {
		toMonthDay, toHm, noScheduleNoChecks,

		/**
		 * Розбиває "MM.DD" на ["MM","DD"] і зберігає в modMonthDay.
		 * @param {string|number} monthDay - рядок або число у форматі "MM.DD"
		 * @returns {void}
		 */
		modDays(monthDay) {
			const str = String(monthDay ?? '').trim();
			const [ mm = '', dd = '' ] = str.split('.', 2);
			this.modMonthDay = [ mm, dd ];
		},

		/*
		 * Парсить "HH:mm" або "HH:mm:ss" (дозволяє однозначні години/хвилини типу "9:5").
		 * Повертає {h, m, s} або null, якщо формат/діапазон некоректний.
		 * seconds необов'язкові.
		 * @param {string} time
		 * @returns {{h:number,m:number,s:number}|null}
		 */
		parseHMS(time) {
			if (typeof time !== 'string') return null;
			const str = time.trim();
			const match = str.match(/^(\d{1,2})(?::(\d{1,2})(?::(\d{1,2}))?)?$/);
			if (!match) return null;

			const h = Number(match[1]);
			const m = Number(match[2] || 0);
			const s = Number(match[3] || 0);

			// базова валідація діапазонів
			if (h < 0 || h > 23) return null;
			if (m < 0 || m > 59) return null;
			if (s < 0 || s > 59) return null;

			return { h, m, s };
		},

		/*
		 * Чи є значення часу «строго нульовим» (00:00 або 00:00:00)?
		 * Порожні/некоректні значення НЕ вважаємо нульовими.
		 * @param {string} time
		 * @returns {boolean}
		 */
		isZeroTime(time) {
			const v = this.parseHMS(time);
			return !!v && v.h === 0 && v.m === 0 && v.s === 0;
		},

		/*
		 * Чи є «реальне» значення часу (не порожнє/валідне і не 00:00(:00))?
		 * @param {string} time
		 * @returns {boolean}
		 */
		hasTimeValue(time) {
			const v = this.parseHMS(time);
			return !!v && !(v.h === 0 && v.m === 0 && v.s === 0);
		},

		/*
		 * Перетворює "HH:mm" або "HH:mm:ss" у хвилини.
		 * @param {string} time Рядок часу, напр. "09:00" або "09:00:30".
		 * @return {number} Кількість хвилин.
		 */
		parseToMinutes(time) {
			if (!time || typeof time !== 'string') return 0;
			const parts = time.split(':'); // ["HH","mm","ss?"]
			const h = Number(parts[0]) || 0;
			const m = Number(parts[1]) || 0;
			return (h * 60) + m; // секунди не враховуємо
		},
			
		/*
			 * Розраховує тривалість зміни між schedule_in та schedule_out у хвилинах.
			 * Підтримка перетину півночі: out < in => додаємо 24 години.
			 * @param {string} inTime  "HH:mm" або "HH:mm:ss"
			 * @param {string} outTime "HH:mm" або "HH:mm:ss"
			 * @return {number} Хвилини запланованої зміни.
			 */
		getScheduledMinutes(inTime, outTime) {
			const start = this.parseToMinutes(inTime);
			let end = this.parseToMinutes(outTime);
			if (end < start) end += 24 * 60; // через північ
			return end - start;
		},

		/*
			 * Форматує хвилини у "HH:mm" з ведучими нулями.
			 * @param {number} minutes Додатні хвилини (абсолютне значення).
			 * @return {string} Формат "HH:mm".
			 */
		formatMinutes(minutes) {
			const abs = Math.max(0, Math.floor(minutes));
			const h = String(Math.floor(abs / 60)).padStart(2, '0');
			const m = String(abs % 60).padStart(2, '0');
			return `${ h }:${ m }`;
		},

		onEventIconBtn(key) {
			this.$emit('updateEventIconBtn', { key });
		},

		updateRowInfo() {
			if (this.item) {
				const {
					sick,
					vacation,
					duty,
					remote,
					holiday,
				} = this.item;

				this.duty = duty;
				this.remote = remote;
				this.holiday = holiday;

				this.isRemote = remote && !duty && !sick && !vacation && !holiday;
				this.isDuty = duty && !remote && !sick && !vacation && !holiday;
				this.isHoliday = holiday && !duty && !remote && !sick && !vacation;

			}
		}
	},
	mounted() {
		this.updateRowInfo();
		this.modDays(toMonthDay(this.item.date));
	},
	watch: {
		item(val, oldVal) {
			if (val !== oldVal) {
				this.updateRowInfo();
				this.modDays(toMonthDay(this.item.date));
			}
		},
	},
};
</script>

<style scoped lang="scss">
.monthDay {
	border: 1px solid var(--rowDay-duty-to);
	background-color: var(--card-bg);
	display: flex;
	flex-direction: column;
	&.disabled {
		background-color: var(--card-shadow);
		cursor: not-allowed;
	}
	&.noScheduleNoChecks {
		@media screen and (max-width: 1000px) {
			background-color: var(--base-red-op-1);
		}
		.iconWr {
			@media screen and (max-width: 1000px) {
				display: none;
			}
		}
	}
	.head {
		padding: 4px 6px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 3px;
		background: var(--card-table-body-bg-hover);

		@media screen and (max-width: 1380px) {
			gap: 6px 3px;
		}
		@media screen and (max-width: 1000px) {
			margin-bottom: 0px;
		}
		.dayName {
			display: none;
			padding: 3px 6px;
			border-radius: 6px;
			font-size: 12px;
			background: var(--card-table-body-bg-hover);
			@media screen and (max-width: 1000px) {
				display: block;
			}
		}
		.eventDay {
			display: none;
			@media screen and (max-width: 1000px) {
				display: flex;
			}
		}
		.total_time {
			display: block;
			@media screen and (max-width: 1000px) {
				display: none;
			}
			.totalTimeRow {
				height: 100%;
				gap: 3px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}
	.itemWrap {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 3px;
		flex-wrap: wrap;
	}
	.item {
		display: flex;
		align-items: center;
		gap: 3px;
		svg {

		}
		.value {

		}
	}
	.date {
		.iconWrap {
			position: relative;
			width: 20px;
			height: 20px;
			cursor: default;
			svg {
				position: absolute;
				z-index: 1;
				color: var(--card-color-sub-title);
			}
			.mm {
				position: relative;
				font-size: 10px;
				color: var(--base-green);
				top: 8px;
				left: 0;
				z-index: 2;
				width: 100%;
				text-align: center;
			}
		}

		.value {
			cursor: default;
			display: flex;
			align-items: flex-end;

		}

	}
	.dayControls {
		flex: 1;
		justify-content: flex-end;
		@media screen and (max-width: 1360px) {
			order: 3;
			width: 100%;
		}
		@media screen and (max-width: 1000px) {
			order: inherit;
			width: 100%;
		}

	}
	.total_time {
		svg {
			color: var(--base-orange);
		}
		.value {
			min-width: 42px;
		}
	}

	.main {

		@media screen and (max-width: 1000px) {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 3px;
			flex-wrap: wrap;
			justify-content: space-between;
			padding: 4px 6px;
		}
		.total_time {
			display: none;
			@media screen and (max-width: 1000px) {
				display: flex;
			}
			.totalTimeRow {
				height: 100%;
				gap: 3px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

	}

	.checkWrap {
		padding: 4px;
		min-height: 30px;
		min-width: 145px;
	}
	.check {
		&.in {
			svg {
				color: var(--base-green);
			}
		}
		&.out {
			svg {
				color: var(--base-red);
			}
		}
	}
	.scheduleWrap {
		padding: 4px;
		border-top: 1px solid var(--card-table-body-bg-hover);
		margin-top: 4px;
		color: var(--card-color-sub-title);
		justify-content: space-between;
		position: relative;

		@media screen and (max-width: 1000px) {
			padding: 0;
			border-top: none;
			margin-top: 0;
		}
		.schedule {
			font-size: 12px;
			&.in {
				svg {
					color: var(--base-green-dark);
				}
			}
			&.out {
				svg {
					color: var(--base-red-dark);
				}
			}
		}

		.ow {
			margin-left: auto; // притискаємо вправо
			display: flex;
			align-items: center;
		}

	}

	.owBadge {
		font-size: 12px;
		font-weight: 600;
		line-height: 1;
		padding: 3px 6px;
		border-radius: 6px;
		background: var(--card-table-body-bg-hover);

		&--less { color: var(--base-red); }
		&--more { color: var(--base-green); }
		&--ok   { color: var(--base-orange); }
	}

	.iconWr {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.eventDay {
		display: flex;
		align-items: center;
		gap: 3px;
		justify-content: center;
		color: var(--card-color-sub-title);
		padding: 6px;
		border-radius: 0px;
		background: var(--card-table-body-bg-hover);
		flex: 1;

		@media screen and (max-width: 1000px) {
			padding: 3px 6px;
			display: none;
			border-radius: 6px;
			flex: inherit;
		}

		.icon {
			@media screen and (max-width: 1000px) {
				width: 21px;
				height: 21px;
			}

			svg {
				@media screen and (max-width: 1000px) {
					display: block;
					width: 100% !important;
					height: 100% !important;
				}
			}
		}

		&.vacation {
			background: var(--base-yellow-opacity);
			.icon {
				color: var(--base-orange);
				&.payed {
					color: var(--base-yellow);
				}
			}
		}
		&.sick {
			background: var(--base-red2);
			.icon {
				color: var(--base-red);
				&.payed {
					color: var(--base-red-dark);
				}
			}
		}
		&.duty
		&.remote,
		&.holiday {
			background: var(--base-green2);
			.icon {
				color: var(--base-green);
			}
		}
		.text {
			font-size: 12px;
		}

	}

}
</style>
